<template>
  <div class="row">
    <div class="header-img col-xs-12">
      <img class="img-responsive" :src="src" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'header-img',

  props: {
    src: {
      type: String,
      required: true
    }
  }
}
</script>
<style scoped lang="less">
.img-responsive {
    border-radius: 1rem;
}
</style>
